import React from 'react';
import styled, { ThemeProvider, withTheme } from 'styled-components';

const Row = styled.div`
  border-bottom: 2px solid #cacfd9;
`;

const Title = styled.div`
  padding: 10px 5px;
  background: #d6d9df;
`;

const List = styled.div`
  width: auto;
  overflow: scroll;
`;

const FavList = ({ theme, title, children }) => (
  <ThemeProvider theme={theme}>
    <Row>
      <Title>{title}</Title>
      <List>{children}</List>
    </Row>
  </ThemeProvider>
);

export default withTheme(FavList);



// WEBPACK FOOTER //
// ./src/components/Category.js